<template>
  <div class="feedback">
    <div class="error-correction" @click="onErrorCorrection">
      <img src="@/assets/纠错2.png" v-if="black" />
      <img src="@/assets/纠错灰色.png" v-else />
      <div>纠错</div>
    </div>
    <div class="feedback-dialog" v-show="dialogShow">
      <div class="body" v-if="!success">
        <div class="title">请选择或填写需要纠错的内容</div>
        <div class="tags">
          <Tag
            ref="tag"
            :text="item"
            v-for="(item, index) in ['图文不符', '内容有误', '文字错误', '信息错误', '信息未更新']"
            :key="index"
          />
        </div>
        <textarea v-model="content" placeholder="请输入您的纠错信息"></textarea>
        <div>
          <button :class="content.length > 0 ? 'active' : ''" @click="send">发送</button>
        </div>
      </div>
      <div class="success" v-else>
        <img src="@/assets/index/反馈成功.png" />
        <div class="title">反馈成功！</div>
        <div class="content">非常感谢您的反馈，美好的用户体验离不开您的宝贵建议！</div>
      </div>
      <div class="close" @click="dialogShow = false; success = false">
        <img src="@/assets/index/叉.png" />
      </div>
    </div>
  </div>
</template>

<script>
import Tag from "./Tag";
export default {
  name: "Feedback",
  components: {
    Tag
  },
  props: {
    black: {
      type: Boolean,
      default: false
    },
    targetName: {
      type: String
    },
    targetId: {
      type: String
    }
  },
  data() {
    return {
      type: "我要纠错",
      dialogShow: false,
      content: "",
      success: false
    };
  },
  methods: {
    onErrorCorrection() {
      this.type = "我要纠错";
      this.dialogShow = true;
      this.success = false;
      this.content = "";

      this.ajax.doPost({
        packageName: "user",
        className: "userAnalysis",
        methodName: "create",
        params: {
          userId: this.$store.state.sys.sysUser.me.id,
          moduleName: "联系我们-纠错",
          moduleResourceId: this.$route.params.id,
          path: this.$route.path
        }
      });
    },
    onFeedback() {
      this.type = "产品反馈";
      this.dialogShow = true;
      this.success = false;
      this.content = "";

      this.ajax.doPost({
        packageName: "user",
        className: "userAnalysis",
        methodName: "create",
        params: {
          userId: this.$store.state.sys.sysUser.me.id,
          moduleName: "联系我们-反馈",
          moduleResourceId: this.$route.params.id,
          path: this.$route.path
        }
      });
    },
    async send() {
      if (!this.content) {
        this.$message({
          type: "error",
          message: "请输入内容！",
          duration: 5000
        });
        return;
      }
      const tags = this.$refs["tag"]
        .filter(e => e.status)
        .map(e => e.text)
        .join(",");

      const result = await this.ajax.doPost({
        packageName: "user",
        className: "feedback",
        methodName: "create",
        params: {
          userId: this.$store.state.sys.sysUser.me.id,
          type: this.type,
          targetName: this.targetName,
          targetId: this.targetId,
          tags: tags,
          content: this.content,
          processStatus: "未处理"
        }
      });

      this.success = true;
    }
  }
};
</script>

<style lang="less" scoped>
.feedback {
  display: inline-block;
  margin-right: 15px;
  position: relative;
  border-radius: 16px;

  border: 1px solid rgba(191, 191, 191, 1);

  color: rgba(0, 0, 0, 1);
  //   width: 100px;
}
.error-correction {
  display: inline-block;
  vertical-align: top;
  // border-radius: 16px;
  height: 30px;

  text-align: center;
  cursor: pointer;

  img {
    width: 15px;
    height: 15px;
    display: inline-block;
    margin: 7px 10px 10px 20px;
  }
  div {
    margin: 5px 15px 5px 0px;
    display: inline-block;
    line-height: 20px;
    vertical-align: top;
    font-size: 14px;
  }
}
.feedback-dialog {
  width: 280px;
  //   height: 600px;
  position: absolute;
  top: 60px;
  left: 45px;
  z-index: 2;
  .body {
    width: 280px;
    height: 350px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);

    .title {
      font-size: 16px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 62px;
      height: 62px;
      margin-left: 18px;
    }

    .tags {
      margin-left: 18px;
      text-align: left;
    }

    textarea {
      width: 244px;
      height: 114px;
      background: rgba(245, 245, 245, 1);

      border: 0;
      outline: 0;

      padding: 18px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 17px;
      resize: none;
    }

    textarea::placeholder {
      font-size: 12px;
      font-weight: 400;
      color: rgba(191, 191, 191, 1);
      line-height: 17px;
    }

    button {
      width: 85px;
      height: 38px;
      background: rgba(191, 191, 191, 1);

      cursor: pointer;

      border: 0;
      outline: 0;

      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;

      float: right;
      margin: 12px 18px 0 0;
    }

    button.active {
      color: white;
      background: rgba(64, 177, 93, 1);
    }
  }

  .success {
    width: 280px;
    height: 280px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);
    text-align: center;
    img {
      width: 50px;
      height: 50px;

      margin-top: 75px;
    }

    .title {
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      margin: 10px;
    }

    .content {
      margin: 18px;
      font-size: 12px;

      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 17px;
    }
  }

  .close {
    width: 38px;
    height: 38px;
    background: rgba(227, 50, 71, 1);
    box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);

    text-align: center;
    line-height: 38px;

    float: right;
    margin-top: 20px;

    cursor: pointer;
    img {
      width: 13px;
    }
  }
}
</style>